import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDate',
  standalone: true,
})
export class FormatDatePipe implements PipeTransform {
  transform({
    value,
    format = 'dd.mm.yyyy',
  }: {
    value: Date | string | number;
    format?: string;
  }): string {
    const date = new Date(value);

    if (isNaN(date.getTime())) {
      return '';
    }

    return format
      .replace('yyyy', date.getFullYear().toString())
      .replace('MM', this.pad(date.getMonth() + 1))
      .replace('dd', this.pad(date.getDate()))
      .replace('HH', this.pad(date.getHours()))
      .replace('mm', this.pad(date.getMinutes()))
      .replace('ss', this.pad(date.getSeconds()));
  }

  private pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }
}
